import { CostUnit } from '@repo/api-gw-sdk';

const threshold = 0.01;

export const formatNumber = (value: number, fractionDigits = 2) => {
  if (fractionDigits && threshold > value && value > 0) {
    return `<${threshold}`;
  }

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

const compactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

export const formatCompactNumber = (value: number) =>
  compactFormatter.format(value);

const withCurrencyPrefix = (formatted: string, costUnit: CostUnit) => {
  if (costUnit !== CostUnit.COST_UNIT_USD) return formatted;
  return formatted.startsWith('<')
    ? `<$${formatted.slice(1)}`
    : `$${formatted}`;
};

export const formatAmount = (
  value: number,
  costUnit: CostUnit,
  fractionDigits = 2
) => withCurrencyPrefix(formatNumber(value, fractionDigits), costUnit);

export const formatCompactAmount = (value: number, costUnit: CostUnit) =>
  withCurrencyPrefix(formatCompactNumber(value), costUnit);
